export default "__VITE_ASSET__BQnTeZ$f__"